import React, { useContext, useEffect, useState } from "react";
import { Measurement } from "../../../goal_templates/classes/measurements/measurement";
import { NumericInput } from "../../../goal_templates/common/components/generalUtilities";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";

export const DefaultInitialValue = ({
  checkDecimals,
  goal,
  initialReading,
  handleInitialReading,
}) => {
  const { t } = useContext(TMDataContext);

  const [formattedReading, setFormattedReading] = useState<number | null>();

  var useManualReadingId = "enter-manual-reading";
  var useManualReadingLabel = "enter-manual-reading-label";

  useEffect(() => {
    handleInitialReading(formattedReading);
  }, [formattedReading]);

  const processInputValue = (input) => {
    if (checkDecimals(input)) setFormattedReading(input);
  };
  return (
    <span className="set-default-initial-reading-wrapper">
      <div className="goal-form-radio-button-wrapper stacked-options">
        <div className="goal-form-radio-button-wrapper">
          <label
            htmlFor={useManualReadingId}
            id={useManualReadingLabel}
            style={{ marginBottom: "0px", marginRight: "7px" }}
          >
            {t("views.goals.contexts.Observation.initial_reading_manual")}
          </label>
        </div>
        <NumericInput
          id={useManualReadingId}
          handleValue={processInputValue}
          state={initialReading == null ? "" : initialReading}
        />
        <span id="manual-reading-units" style={{ marginLeft: "5px" }}>
          {goal.measurement.unitsOnly()}
        </span>
      </div>
    </span>
  );
};
